import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WsJsonMessage } from 'types/websocket.types';
import { LoadingState } from 'types/enums';
import { fetchCreateSignedConnectionUrlEffect } from './effects';

export interface WebSocketsState {
  isWebSocketLive: boolean;
  connectionUrl: string | null;
  subscriptionResource?: string;
  activityPingInterval?: number;
  connectionUrlLoadingState: LoadingState;
}

export const webSocketsInitialState: WebSocketsState = {
  isWebSocketLive: false,
  connectionUrl: null,
  connectionUrlLoadingState: LoadingState.PRISTINE,
};

const slice = createSlice({
  name: 'webSockets',
  initialState: webSocketsInitialState,
  reducers: {
    setIsWebSocketLive(state, { payload }: PayloadAction<{ isLive: boolean }>) {
      state.isWebSocketLive = payload.isLive;
    },
    setWebSocketConnectionData(
      state,
      { payload }: PayloadAction<string | null>
    ) {
      state.connectionUrl = payload;
    },
    setSubscriptionResource(
      state,
      { payload }: PayloadAction<{ subscriptionResource?: string }>
    ) {
      state.subscriptionResource = payload.subscriptionResource;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    handleWebSocketMessage(_, __: PayloadAction<WsJsonMessage>) {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCreateSignedConnectionUrlEffect.pending, (state) => {
        state.connectionUrlLoadingState = LoadingState.FETCHING;
      })
      .addCase(
        fetchCreateSignedConnectionUrlEffect.fulfilled,
        (state, action) => {
          state.connectionUrlLoadingState = LoadingState.FETCHED;
          if (!action.payload) {
            return;
          }
          state.connectionUrl = action.payload.connectionUrl;
          state.activityPingInterval = action.payload.activityPingInterval;
        }
      )
      .addCase(fetchCreateSignedConnectionUrlEffect.rejected, (state) => {
        state.connectionUrlLoadingState = LoadingState.ERROR;
      });
  },
});

export const {
  setIsWebSocketLive,
  setWebSocketConnectionData,
  setSubscriptionResource,
  handleWebSocketMessage,
} = slice.actions;

export const webSocketsReducer = slice.reducer;
